import {
  Button,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography
} from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import RemoveIcon from "@material-ui/icons/Remove";
import { withStyles } from "@material-ui/styles";
import { format } from "date-fns";
import {
  cancelServiceId,
  statusReportServiceId,
  STATUS_PROCESS
} from "libs/configs/constant";
import { CANCEL_STEP, STATUS_REPORT_STEP } from "libs/constant/VisaStep";
import useModalLoading from "libs/hooks/useModalLoading";
import PropTypes from "prop-types";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getAllDocumentsList } from "redux/modules/allDocumentsSlice";
import { setStep as cancelSetStep } from "redux/modules/cancelVisaSlice";
import { setStep } from "redux/modules/statusReportSlice";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  warpListVisa: {
    marginTop: 50,
  },
  warpButton: {
    marginTop: 30,
    // display: 'flex',
    // justifyContent: 'space-between',
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  warpForm: {
    marginTop: 30,
  },
  warpRespon: {
    textAlign: "right",
    marginTop: 15,
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
    textAlign: "center",
  },
  buttonViewDetail: {
    // width: 150,
    backgroundColor: "#00D0FF",
  },
  warpButtonDetail: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonStatusDetail: {
    marginLeft: 15,
    backgroundColor: "white",
    padding: 5,
    borderRadius: "50%",
    boxShadow: "0px 0px 2px 2px rgba(23, 43, 77, 0.2)",
  },

  rowPopover: {
    // position: 'relative',
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  popover: {
    pointerEvents: "none",
  },
  popoverContent: {
    // pointerEvents: 'auto',
  },
  rowMenuPopOver: {
    padding: 15,
  },
  rowPopTitle: {
    paddingBottom: "15px",
    borderBottom: "1px solid lightgray",
    fontWeight: "500",
    color: "#101A5F",
    textAlign: "center",
    marginBottom: 15,
  },
  rowPopItem: {
    padding: 5,
    fontWeight: "500",
    color: "#101A5F",
    display: "flex",
    justifyContent: "flex-start",
  },
  iconPop: {
    color: "white",
    fontWeight: "bold",
    marginRight: "10px",
    borderRadius: "50%",
    verticalAlign: "middle",
    width: "25px",
    height: "25px",
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default function AllDocuments(props) {
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("modDate");
  const classes = useStyles();
  const dispatch = useDispatch();

  const { userID } = useSelector((state) => state.auth);
  const history = useHistory();
  const { hideLoading, showLoading } = useModalLoading();
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  useEffect(() => {
    dispatch(getAllDocumentsList());
  }, [dispatch]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [configApprveSmartFrom, setConfigApprveSmartFrom] = useState([]);

  const popoverEnter = (data, e) => {
    setSelectedId(data.id);
    setConfigApprveSmartFrom(data.configApprveSmartFrom);
    setAnchorEl(e.currentTarget);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const popoverLeave = () => {
    setSelectedId(null);
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleClickViewDetail = async (row) => {
    // const isOwnDoc = row.staffID === userID;
    // if (row.statusProcessId === 'P' && isOwnDoc) {
    //   await dispatch(viewDoc(row.draftId))
    // }
    if (props.isPreapprove) {
      history.push(`/admin/smart-visa/preapprove/${row.draftId}`);
      return;
    }

    showLoading();
    if (row.smartserviceId === cancelServiceId) {
      dispatch(cancelSetStep(CANCEL_STEP.CANCEL_A));
      history.push(
        `/admin/smart-visa/cancel-visa/${row.personalId}?draftId=${row.draftId}`
      );
      hideLoading();
    } else if (row.smartserviceId === statusReportServiceId) {
      history.push(
        `/admin/smart-visa/status-report/${row.personalId}?draftId=${row.draftId}`
      );
      dispatch(setStep(STATUS_REPORT_STEP.STATUS_REPORT_STEP_A));
      hideLoading();
    } else {
      if (
        row.statusProcessId === STATUS_PROCESS.VisaIssuance ||
        row.statusProcessId === STATUS_PROCESS.VisaReceived ||
        row.statusProcessId === STATUS_PROCESS.Complete
      ) {
        history.push(`/admin/smart-visa/document/${row.draftId}`);
      } else {
        history.push(`/admin/smart-visa/document/${row.draftId}`);
      }

      hideLoading();
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = props?.smartList.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <div>
      <TableContainer>
        <Table className={classes.table} aria-label="customized table">
          <EnhancedTableHead
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={props?.smartList.length}
          />
          {/*    <TableHead ><TableRow>
              <StyledTableCell className={classes.tableHead}>
                DATE
              </StyledTableCell>
              <StyledTableCell className={classes.tableHead}>
                DOC No.
              </StyledTableCell>
              <StyledTableCell className={classes.tableHead} style={{ textAlign: 'left' }}>
                First name
              </StyledTableCell>
              <StyledTableCell className={classes.tableHead} style={{ textAlign: 'left' }}>
                Last name
              </StyledTableCell>
              <StyledTableCell className={classes.tableHead}>
                Smart Type
              </StyledTableCell>
              <StyledTableCell className={classes.tableHead}>
                Doc Type
              </StyledTableCell>
              <StyledTableCell className={classes.tableHead}>
                STATUS
              </StyledTableCell>
              <StyledTableCell className={classes.tableHead}>
                STAFF
              </StyledTableCell>
              <StyledTableCell className={classes.tableHead}>
                ACTION
              </StyledTableCell>
            </TableRow>     </TableHead> */}

          <TableBody>
            {/* {props?.smartList.map((row) => (
              <StyledTableRow key={row.name}>
                <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                  {format(new Date(row.smartDate), "yyyy-MM-dd HH:mm")}
                </StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>{row.smartNo}</StyledTableCell>
                <StyledTableCell>{row.firstname}</StyledTableCell>
                <StyledTableCell>{row.lastname}</StyledTableCell>
                <StyledTableCell>{row.smartserviceReferName}</StyledTableCell>

                <StyledTableCell style={{ textAlign: 'center' }}>

                  <Typography className={classes.rowPopover} aria-describedby={row.draftId}
                    onMouseEnter={(e) => popoverEnter(row, e)}
                    onMouseLeave={() => popoverLeave()}
                    aria-haspopup="true">
                    {
                      row.statusProcessId === STATUS_PROCESS.Complete &&
                      <Brightness1Icon style={{ verticalAlign: "middle", paddingRight: 5, color: "#2DCE98" }}></Brightness1Icon>

                    }
                    {

                      row.statusProcessId !== STATUS_PROCESS.Complete &&
                      row.statusProcessId !== STATUS_PROCESS.Rejected &&
                      row.statusProcessId !== STATUS_PROCESS.FinalRejected
                      &&
                      <Brightness1Icon style={{ verticalAlign: "middle", paddingRight: 5, color: "#FEB969" }}
                      ></Brightness1Icon>
                    }
                    {
                      row.statusProcessId === STATUS_PROCESS.Rejected ||
                      row.statusProcessId === STATUS_PROCESS.FinalRejected &&
                      <Brightness1Icon style={{ verticalAlign: "middle", paddingRight: 5, color: "#F53C56" }}></Brightness1Icon>
                    }
                    <span>{row.typeDocSmartFromName}</span>

                  </Typography>


                </StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>{row.statusProcessName}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>{row.staffname}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>
                  {
                    (row.statusProcessId !== 'D' ||
                      (row.statusProcessId === 'D' && row.smartNo)) &&
                    <div className={classes.warpButtonDetail}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className={classes.buttonViewDetail}
                        onClick={() => handleClickViewDetail(row)}
                      >
                        View
                      </Button>
                    </div>
                  }

                </StyledTableCell>
              </StyledTableRow>


            ))} */}

            {stableSort(props?.smartList, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    style={{ textAlign: "center" }}
                  >
                    {format(new Date(row.modDate), "yyyy-MM-dd HH:mm")}
                  </StyledTableCell>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    style={{ textAlign: "center" }}
                  >
                    {format(new Date(row.submitDate), "yyyy-MM-dd")}
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    {row.smartNo}
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    {row.nrNo}
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    {row.svNo}
                  </StyledTableCell>
                  <StyledTableCell>{row.firstname}</StyledTableCell>
                  <StyledTableCell>{row.lastname}</StyledTableCell>
                  <StyledTableCell>{row.smartserviceName}</StyledTableCell>

                  <StyledTableCell style={{ textAlign: "center" }}>
                    <Typography
                      className={classes.rowPopover}
                      aria-owns={open ? row.draftId : undefined}
                      aria-describedby={row.draftId}
                      onMouseEnter={(e) => popoverEnter(row, e)}
                      onMouseLeave={() => popoverLeave()}
                      aria-haspopup="true"
                    >
                      {row.statusProcessId === STATUS_PROCESS.Complete && (
                        <Brightness1Icon
                          style={{
                            verticalAlign: "middle",
                            paddingRight: 5,
                            color: "#2DCE98",
                          }}
                        ></Brightness1Icon>
                      )}
                      {row.statusProcessId !== STATUS_PROCESS.Complete &&
                        row.statusProcessId !== STATUS_PROCESS.Rejected &&
                        row.statusProcessId !==
                        STATUS_PROCESS.FinalRejected && (
                          <Brightness1Icon
                            style={{
                              verticalAlign: "middle",
                              paddingRight: 5,
                              color: "#FEB969",
                            }}
                          ></Brightness1Icon>
                        )}
                      {row.statusProcessId === STATUS_PROCESS.Rejected ||
                        (row.statusProcessId ===
                          STATUS_PROCESS.FinalRejected && (
                            <Brightness1Icon
                              style={{
                                verticalAlign: "middle",
                                paddingRight: 5,
                                color: "#F53C56",
                              }}
                            ></Brightness1Icon>
                          ))}
                      <span>{row.typeDocSmartFromName}</span>
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    {row.statusProcessName}
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    {row.staffname}
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    {(row.statusProcessId !== "D" ||
                      (row.statusProcessId === "D" && row.smartNo)) && (
                        <div className={classes.warpButtonDetail}>
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className={classes.buttonViewDetail}
                            onClick={() => handleClickViewDetail(row)}
                          >
                            View
                          </Button>
                        </div>
                      )}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={props?.smartList.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Popover
        id={selectedId}
        className={classes.popover}
        classes={{
          paper: classes.popoverContent,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        onClose={popoverLeave}
        disableRestoreFocus
      >
        <div className={classes.rowMenuPopOver}>
          <div className={classes.rowPopTitle}>Organization</div>
          {configApprveSmartFrom.map((row, index) => (
            <div key={row.departmentId} className={classes.rowPopItem}>
              {(row.statusProcessId === STATUS_PROCESS.Complete ||
                row.statusProcessId === STATUS_PROCESS.Processing ||
                row.statusProcessId === STATUS_PROCESS.Approved) && (
                  <Fragment>
                    <div
                      className={classes.iconPop}
                      style={{ backgroundColor: "#2DCE98" }}
                    >
                      <CheckIcon></CheckIcon>
                    </div>
                    <span>
                      {row.departmentName} ({row.empFirstName} {row.empLastName})
                    </span>
                  </Fragment>
                )}
              {(row.statusProcessId === STATUS_PROCESS.Pending ||
                row.statusProcessId === STATUS_PROCESS.UploadAddDoc ||
                row.statusProcessId === STATUS_PROCESS.RequestAddDoc) && (
                  <Fragment>
                    <div
                      className={classes.iconPop}
                      style={{ backgroundColor: "#FEB969" }}
                    >
                      <RemoveIcon></RemoveIcon>
                    </div>
                    <span>
                      {row.departmentName} ({row.empFirstName} {row.empLastName})
                    </span>
                  </Fragment>
                )}
              {(row.statusProcessId === STATUS_PROCESS.Rejected ||
                row.statusProcessId === STATUS_PROCESS.FinalRejected) && (
                  <Fragment>
                    <div
                      className={classes.iconPop}
                      style={{ backgroundColor: "#F53C56" }}
                    >
                      <CloseIcon></CloseIcon>
                    </div>
                    <span>
                      {row.departmentName} ({row.empFirstName} {row.empLastName})
                    </span>
                  </Fragment>
                )}
            </div>
          ))}
        </div>
      </Popover>
    </div>
  );
}

const headCells = [
  {
    id: "modDate",
    numeric: false,
    disablePadding: false,
    label: "MODIFIED DATE",
  },
  {
    id: "submitDate",
    numeric: false,
    disablePadding: false,
    label: "SUBMIT DATE",
  },
  {
    id: "smartNo",
    numeric: false,
    disablePadding: false,
    label: "DOC No.",
  },
  {
    id: "nrNo",
    numeric: false,
    disablePadding: false,
    label: "เลขที่ นร",
  },
  {
    id: "SvNo",
    numeric: false,
    disablePadding: false,
    label: "เลขที่ลงรับ",
  },
  {
    id: "firstname",
    numeric: false,
    disablePadding: false,
    label: "First name",
  },
  {
    id: "lastname",
    numeric: false,
    disablePadding: false,
    label: "Last name",
  },
  {
    id: "smartserviceReferName",
    numeric: false,
    disablePadding: false,
    label: "Visa Type",
  },
  {
    id: "typeDocSmartFromName",
    numeric: false,
    disablePadding: false,
    label: "Doc Type",
  },

  {
    id: "statusProcessName",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "staffname",
    numeric: false,
    disablePadding: false,
    label: "Staff",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
    disabled: true,
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const classes = useStyles();
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            className={classes.tableHead}
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              // disabled={headCell?.disabled || true}
              disabled={headCell?.disabled}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
